module.exports = __webpack_public_path__ + "static/media/all.4df345fd.pred";